import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import addIcon from '../../../assets/svg/add-icon-v2.svg'
import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import saveIcon from '../../../assets/svg/save-icon.svg';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'


import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import { fi, id, th } from 'react-date-range/dist/locale';
import CustomCalendarFilterSelect from '../../calendar/customCalendarFilterSelect';
import SearchPatientsField from './searchPatientsField';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import { getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class CreatePayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            },
            cases: [],
            paymentMethods: []
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const currency = this.getCurrency();
        const patientId = this.props.patientId; // || '628b78310a0bbcf82f688bca';
        let form = {
            patientId: patientId || null,
            selectPatientDisabled: patientId ? true : false,
            price: '0',
            currency: currency,
            addVatRate: false,
            vatRate: null,
            paymentMethods: [],
            caseId: null,
            note: '',
            messageToPatient: ''
        }

        this.setState({ form, currency }, () => {
            if (this.state.form?.patientId) {
                this.findPatient();
            }
        })
    }
    checkPaymentMethods = () => {

        const groupData = this.getGroupData();

        const paymentMethods = getGroupPaymentMethods(groupData, this.props.lang);

        let setObj = { paymentMethods };

        this.setState(setObj)
    }
    findPatient = () => {
        let form = this.state.form;
        const patientId = form.patientId || null;
        const groupId = this.props.selectedGroup || null;
        if (patientId && patientId?.length === 24 && groupId) {
            this.getCases();

            fetch(API_ENDPOINT + `/api/payments/patient-data/${groupId}/${patientId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result?._id) {
                    let patientData = { ...result };
                    let form = {
                        ...this.state.form,
                        patientData: patientData
                    };
                    this.setState({ form }, () => {
                        this.checkPaymentMethods();
                    });
                }
            })

        }
    }
    getCases = () => {
        const patientId = this.state.form?.patientId || null;
        const groupId = this.props.selectedGroup || null;
        const clinicId = this.props.selectedClinic || null;
        if (!patientId || !groupId || !clinicId) return;

        fetch(API_ENDPOINT + `/api/payments/cases/${groupId}/${clinicId}/${patientId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(res => res.json()).then((result) => {
            const SCHEDULED_STATUSES = ['scheduled', 'visit-rescheduled', 'revisit-scheduled']
            const cases = result?.length ? result?.map((item, idx) => {
                if (item?.visitDateTs && SCHEDULED_STATUSES.includes(item?.status)) {
                    item.visitDate = this.props.getStringDateTs(item.visitDateTs, this.props.dateFormat + ' HH:mm')
                }
                return item;
            }) : [];
            this.setState({ cases }, () => {
                if (this.props.caseId) {
                    const selectedCase = cases.find(c => c._id === this.props.caseId);
                    let form = this.state.form;
                    if (selectedCase) {
                        form.caseId = selectedCase._id;
                        this.setState({ form });
                    }
                }
            });
        })
    }

    get = () => {

    }

    componentDidMount() {
        this.get();
        this.setInitialData();

        this.checkIfExtendedPaymentManagementEnabled();
    }
    checkIfExtendedPaymentManagementEnabled = () => {
        const groupData = this.getGroupData();
        if (groupData?._id) {
            const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
            if (!EXTENDED_PAYMENT_MANAGEMENT) {
                this.onClose();
            }
        }
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }


    uploadDocument = (e) => {
        let input = e.target;
        if (input.files && input.files[0]) {

            let fsize = input.files[0].size;
            let file = Math.round((fsize / 1024))
            this.setState({
                uploadTimestampDoc: Math.floor(new Date().getTime() / 1000)
            })
            if (file > 10240) {
                this.setState({ error: "File size limit has been reached! (max 10 MB)".translate(this.props.lang) })
            } else {

                if (!this.props.handleFileUpload) this.setState({
                    _documentUploading: true
                })

                let formData = new FormData();
                formData.append('file', input.files[0]);
                formData.append('group', this.props.selectedGroup);
                formData.append('fileType', 'invoices')

                if (this.props.handleFileUpload) {
                    this.props.handleFileUpload?.('/data/upload-document', formData)?.then?.(result => {
                        if (result) {
                            this.setState({
                                attachedInvoiceFile: result,
                                _documentUploading: null
                            })
                        }
                    })
                    return;
                }

                fetch(API_ENDPOINT + '/data/upload-document', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,

                    },
                    body: formData
                }).then(parseText).then(({ result, status }) => {
                    if (status != 200) {
                        this.setState({ error: result.translate(this.props.lang) })
                    } else {
                        this.setState({
                            attachedInvoiceFile: result,
                            _documentUploading: null
                        })
                    }
                })
            }
        }
    }

    toggleAttachInvoiceModal = () => {
        this.setState({ attachInvoiceModal: !this.state.attachInvoiceModal, attachedInvoiceFile: null })
    }

    selectDifferentPatient = () => {
        let form = this.state.form;
        form.patientData = null;
        form.patientId = null;
        this.setState({ form, cases: [] })
    }
    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;

        const data = {
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
            ...form
        }

        this.setState({ loadingInsert: true }, () => {
            fetch(API_ENDPOINT + '/api/payments/insert', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingInsert: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};
        if (!form?.patientId) {
            errors.patientId = 'Patient is required'.translate(this.props.lang);
        }
        const price = form?.price && Number(form?.price) ? Number(form?.price) : 0;
        if (price === 0) {
            errors.price = 'Price is required'.translate(this.props.lang);
        }
        if (price > 0 && !form?.paymentMethods?.length) {
            errors.paymentMethods = 'Payment method is required'.translate(this.props.lang);
        }
        if (
            price > 0
            && form?.paymentMethods?.length === 1
            && form?.paymentMethods?.[0] === 'invoice'
            && !form?.attachedInvoice
        ) {
            errors.attachedInvoice = 'The invoice must be attached'.translate(this.props.lang);
        }
        return Object.keys(errors).length ? errors : null;
    }
    render() {
        const isOpen = this.props.isOpen;

        const currency = this.getCurrency();
        const paymentMethods = this.state.paymentMethods ?? [];
        const cases = this.state.cases ?? [];
        const price = this.state.form?.price && Number(this.state.form?.price) ? Number(this.state.form?.price) : 0;
        const errors = this.state.errors ?? {};

        if (!this.state.form?.patientId || !this.state.form?.patientData?._id) {
            return (
                <>
                    <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                        <ModalHeader
                            toggle={() => this.onClose()}
                            close={
                                <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                            }
                        >
                            {'Create payment request'.translate(this.props.lang)}
                            {/* <div className='modal-header-subtitle'>
                                {'Patient will be notified of the payment request'.translate(this.props.lang)}
                            </div> */}
                        </ModalHeader>

                        <ModalBody className='create-payment-modal-body'>

                            <SearchPatientsField
                                {...this.props}
                                setPatient={(patientId) => {
                                    let form = this.state.form;
                                    form.patientId = patientId;
                                    this.setState({ form }, () => {
                                        this.findPatient();
                                    });
                                }}
                            />


                        </ModalBody>
                        <ModalFooter className='modal-footer-buttons-wrap'>
                            <Button color="primary" onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                        </ModalFooter>
                    </Modal>
                </>
            )
        }
        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Create payment request'.translate(this.props.lang)}
                        <div className='modal-header-subtitle'>
                            {'Patient will be notified of the payment request'.translate(this.props.lang)}
                        </div>
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            <Col lg='12'>
                                <FormGroup>
                                    <Label className='select-patient-wrap'>
                                        {'Patient'.translate(this.props.lang)}
                                        {
                                            !this.props.hideSelectPatient ?
                                                <div className='select-different-patient' onClick={() => this.selectDifferentPatient()}>{'Select patient'.translate(this.props.lang)}</div>
                                                :
                                                null
                                        }
                                    </Label>
                                    <Input type='text' disabled={true} value={`${this.state.form?.patientData?.name} (${this.state.form?.patientData?.socialSecurityNumber})`} />
                                </FormGroup>
                            </Col>
                            <Col lg='6'>
                                <FormGroup className={errors.price ? 'fg-has-error' : ''}>
                                    <Label>{'Price'.translate(this.props.lang)}</Label>
                                    <div className='price-field-wrap'>
                                        <Input
                                            type='text'
                                            value={this.state.form?.price || '0'}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                if (value?.length > 11) return;
                                                let form = this.state.form;
                                                form.price = Number(value);
                                                if (form.price === 0 || !form.price) {
                                                    if (form.addVatRate) {
                                                        form.addVatRate = false;
                                                        form.vatRate = null;
                                                    }
                                                    if (form.paymentMethods?.length) form.paymentMethods = [];
                                                    if (form.attachedInvoice) form.attachedInvoice = null;
                                                }
                                                let setObj = { form };
                                                if (this.state.errors?.price) {
                                                    let errors = this.state.errors;
                                                    delete errors.price;
                                                    setObj.errors = errors;
                                                }
                                                this.setState(setObj);
                                            }}
                                        />
                                        {currency}
                                    </div>
                                    {errors.price ? <div className='error-feedback'>{errors.price}</div> : null}
                                </FormGroup>
                            </Col>
                            <Col lg='6'>
                                <div className='vat-rate-field-wrap'>
                                    <Checkbox
                                        checked={this.state.form?.addVatRate}
                                        onChange={() => {
                                            if (price === 0) return;
                                            let form = this.state.form;
                                            form.addVatRate = !form.addVatRate;
                                            if (!form.addVatRate) {
                                                form.vatRate = null;
                                            }
                                            this.setState({ form });
                                        }}
                                        label={'Add VAT rate'.translate(this.props.lang)}
                                        disabled={price === 0 ? true : false}
                                    />
                                    {
                                        this.state.form?.addVatRate ?
                                            <Input
                                                type='select'
                                                // style={{ width: 200 }}
                                                onChange={(e) => {
                                                    let form = this.state.form;
                                                    form.vatRate = e.target.value;
                                                    this.setState({ form });
                                                }}
                                                value={this.state.form?.vatRate || -1}
                                            >
                                                <option value={-1}>{'VAT-free'.translate(this.props.lang)}</option>
                                                <option value={6}>{'6%'.translate(this.props.lang)}</option>
                                                <option value={12}>{'12%'.translate(this.props.lang)}</option>
                                                <option value={25}>{'25%'.translate(this.props.lang)}</option>


                                            </Input>
                                            :
                                            null
                                    }
                                </div>
                            </Col>
                            {
                                paymentMethods?.length ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.paymentMethods ? 'fg-has-error' : ''}>
                                            <Label>{'Payment method'.translate(this.props.lang)}</Label>
                                            <div className='payment-methods-items-wrap'>
                                                {
                                                    paymentMethods?.map((item, idx) => {
                                                        const isChecked = this.state.form?.paymentMethods?.includes(item.value);
                                                        const isDisabled = price > 0 ? false : true;
                                                        return (
                                                            <div key={idx} className='payment-method-item'>
                                                                <Checkbox
                                                                    checked={isChecked}
                                                                    disabled={isDisabled}
                                                                    onChange={() => {
                                                                        if (isDisabled) return;
                                                                        let form = this.state.form;
                                                                        if (form.paymentMethods?.includes(item.value)) {
                                                                            form.paymentMethods = form.paymentMethods.filter(method => method !== item.value);
                                                                        } else {
                                                                            form.paymentMethods = [...(form.paymentMethods || []), item.value];
                                                                        }
                                                                        let setObj = { form };
                                                                        if (this.state.errors?.paymentMethods) {
                                                                            let errors = this.state.errors;
                                                                            delete errors.paymentMethods;
                                                                            setObj.errors = errors;
                                                                        }
                                                                        this.setState(setObj);
                                                                    }}
                                                                    label={
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                                                                            {item.label}
                                                                            {
                                                                                isChecked && item.value === 'invoice' ?
                                                                                    <div className='icon-with-tooltip-wrap' onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        let attachedInvoiceFile = this.state.form?.attachedInvoice ?? null;
                                                                                        this.setState({ attachInvoiceModal: true, attachedInvoiceFile });
                                                                                    }}>
                                                                                        <Isvg src={attachInvoice} className={errors?.attachedInvoice ? 'attached-invoice-icon-error' : this.state.form?.attachedInvoice ? 'attached-invoice-icon' : ''} />
                                                                                        <div className='tooltip-text'>
                                                                                            {
                                                                                                !this.state.form?.attachedInvoice ?
                                                                                                    'Attach invoice'.translate(this.props.lang)
                                                                                                    :
                                                                                                    'Invoice successfully attached'.translate(this.props.lang)
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    }
                                                                />

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {errors?.paymentMethods ? <div className='error-feedback'>{errors.paymentMethods}</div> : this.state.form?.paymentMethods?.includes('invoice') && errors?.attachedInvoice ? <div className='error-feedback'>{errors.attachedInvoice}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }


                            <Col lg='12'>
                                <FormGroup>
                                    <Label>{this.props.disableCaseSelection ? 'Case'.translate(this.props.lang) : 'Connect payment to existing case (optional)'.translate(this.props.lang)}</Label>
                                    <div
                                        className={this.props.disableCaseSelection ? 'custom-select-with-search' : this.state.caseDropdown ? 'custom-select-with-search-open' : 'custom-select-with-search-closed'}
                                        onClick={() => {
                                            if (this.props.disableCaseSelection) return;
                                            this.setState({
                                                caseDropdown: !this.state.caseDropdown
                                            })
                                        }}
                                    >
                                        {cases?.find(item => item._id === this.state.form?.caseId) ? `${cases?.find(item => item._id === this.state.form?.caseId)?.caseNumber} - ${this.state.form?.patientData?.name} | ${getHumanReadable(cases?.find(item => item._id === this.state.form?.caseId)?.status, this.props.lang)?.status}` : null}

                                    </div>

                                    {
                                        this.state.caseDropdown ?
                                            <div className='custom-select-with-search-items'>
                                                <CustomSelectWithSearch
                                                    lang={this.props.lang}
                                                    items={cases.map((item, idx) => {
                                                        return {
                                                            name: `${item.caseNumber} ${item?.visitReasonName} - ${item?.visitDate ? `${item?.visitDate} ` : ''}${getHumanReadable(item.status, this.props.lang)?.status}`,
                                                            nameComponent: <div style={{ fontSize: 14, fontWeight: 400 }}><span style={{ fontWeight: 600 }}>{item.caseNumber} </span>{` ${item?.visitReasonName} - ${item?.visitDate ? `${item?.visitDate} ` : ''}${getHumanReadable(item.status, this.props.lang)?.status}`}</div>,
                                                            value: item._id
                                                        }
                                                    })}
                                                    value={this.state.form?.caseId}
                                                    maxHeight={'250px'}
                                                    onChange={(e) => {
                                                        const val = e.value !== -1 ? e.value : null;
                                                        let form = this.state.form;
                                                        form.caseId = val;
                                                        this.setState({ form, caseDropdown: false })
                                                    }}
                                                />
                                            </div>
                                            :
                                            null
                                    }
                                </FormGroup>
                            </Col>
                            <Col lg='12'>
                                <FormGroup>
                                    <Label>{'Note'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.note || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.note = e.target.value;
                                            this.setState({ form });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg='12'>
                                <FormGroup>
                                    <Label className='note-label-wrap'>
                                        {'Message to patient'.translate(this.props.lang)}
                                        <div className='notes-icon-wrap'>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Message to patient tooltip'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.messageToPatient || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.messageToPatient = e.target.value;
                                            this.setState({ form });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingInsert}
                        >
                            {'Send request'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>

                <input ref={(node) => this.documentInput = node} type="file" accept=".pdf" key={this.state.uploadTimestampDoc} onChange={this.uploadDocument} style={{ pointerEvents: 'none', opacity: 0 }} />

                {
                    this.state.attachInvoiceModal ?
                        <Modal
                            isOpen={this.state.attachInvoiceModal}
                            centered
                            toggle={() => this.toggleAttachInvoiceModal()}
                        >
                            <ModalHeader toggle={() => this.toggleAttachInvoiceModal()} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggleAttachInvoiceModal()}><Isvg src={xIcon} /></button>}>{'Attach invoice'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody style={{ width: '100%' }}>

                                <button
                                    className={this.state._documentUploading ? 'attach-invoice uploading' : this.state.attachedInvoiceFile ? 'attach-invoice uploaded' : "attach-invoice"}
                                    onClick={() => {
                                        if (this.documentInput) this.documentInput.click()
                                    }}
                                >
                                    <div className="button-menu-icon-wrap">
                                        <Isvg src={attachInvoice} />
                                    </div>
                                    <div className='chat-icons-text'>
                                        {
                                            this.state.attachedInvoiceFile ?
                                                'File uploaded'.translate(this.props.lang)
                                                :
                                                'Attach file'.translate(this.props.lang)
                                        }
                                    </div>
                                </button>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    disabled={!this.state.attachedInvoiceFile}
                                    onClick={() => {
                                        let form = this.state.form;
                                        form.attachedInvoice = this.state.attachedInvoiceFile;
                                        let setObj = { form };
                                        if (this.state.errors?.attachedInvoice) {
                                            let errors = this.state.errors;
                                            delete errors.attachedInvoice;
                                            setObj.errors = errors;
                                        }
                                        this.setState(setObj, () => {
                                            this.toggleAttachInvoiceModal();
                                        });
                                    }}
                                >
                                    {'Save'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' onClick={() => this.toggleAttachInvoiceModal()}>{'Close'.translate(this.props.lang)}</Button>

                            </ModalFooter>


                        </Modal>
                        :
                        null
                }

                {this.state._documentUploading ?
                    <div className="file-progress-loader">
                        <div>
                            <Player
                                onEvent={(event) => {
                                    if (event === "load" && this.player && this.player.current) this.player.current.play();
                                }}
                                ref={this.player} // set the ref to your class instance
                                autoplay={true}
                                loop={true}
                                controls={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                renderer={'svg'}
                                style={{ height: "128px", width: "128px", }}
                            ></Player>
                            <h6>{'Processing file...'.translate(this.props.lang)}</h6>
                        </div>
                    </div>
                    : null}

            </>
        );
    }
}


export default CreatePayment;